<template>
    <div class="tab-zero-container">
        <h1>恭迎小主</h1>
        <h4>资料准备充足，2-3天完成营销型网站</h4>
        <div class="tab-zero-process">

            <div class="process-item" @click="$emit('step', '2')">
                <div class="process-item-div">1
                <!--<div class="process-line"></div>-->
                </div>
                <h5>注册登录</h5>
                <p>页面上注册账号并登录</p>
            </div>
            <div class="process-item" @click="$emit('step', '3')">
                <div class="process-item-div">2
                    <!--<div class="process-line"></div>-->
                </div>
                <h5>选择方案</h5>
                <p>
                    丰富的营销方案供您选择，选择后一键使用
                </p>

            </div>
            <div class="process-item" @click="$emit('step', '5')">
                <div class="process-item-div">3
                    <!--<div class="process-line"></div>-->
                </div>
                <h5>编辑内容</h5>
                <p>在网站编辑器修改相关设置和网站各版块内容</p>
            </div>
            <div class="process-item" @click="$emit('step', '8')">
                <div class="process-item-div">4</div>
                <h5>发布上线</h5>
                <p>完成所有内容设置后一键上线发布网站</p>
            </div>
        </div>
        <!--<p class="step" @click="step">下一步</p>-->
    </div>
</template>

<script>
export default {
	name: 'TabZero',
	methods: {
		// step() {
		//     this.$emit('step', '1')
		// }
	}
}
</script>

<style scoped lang="scss">
    .tab-zero-container{
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        height: 100%;
        padding-top:40px;
        h1{
            font-weight: 400;
            font-size: 70px;
            color:#333333;
        }
        h4{
            font-size: 30px;
            font-weight: 400;
            margin: 20px 0 30px 0;
            color:#333333;
        }
        .tab-zero-process{
            display: flex;
            justify-content: space-between;position: relative;
            width: 80%;
            &:after{
                position: absolute;
                top: 20px;
                content: '';
                width: 80%;
                height: 1px;border-bottom: 1px solid #ccc;
                left: 10%;
            }
            .process-item{
                cursor: pointer;
                z-index:1;
                color:#333;
                width: 150px;
                /*margin-right:20px;*/
                display: flex;
                flex-direction: column;align-items: center;
                &:last-child{
                    margin-right:0;
                }
                div.process-item-div{
                    width: 40px;text-align: center;line-height: 40px; color:#18192a;
                    height: 40px;font-size:20px;font-weight:600;border:1px solid #ccc;position:relative;box-shadow: 20px 0 0 #fff, -20px 0 0 #fff;background: #fff;


                }
                h5{
                    font-size:20px;font-weight: 600;margin:10px 0;color:#212223;
                }
                p{
                    text-align: center;color:#999999;
                }
            }
        }
        p.step{
            margin-top: 80px;margin-left: 580px;cursor:pointer;
        }

    }

</style>
